export enum UbigeoType {
    Country = 'cou',
    Department = 'dep',
    Province = 'pro',
    District = 'dis',
}



// WEBPACK FOOTER //
// ./src/app/shared/_utils/services/ubigeoType.enum.ts